export const SET_STATE = 'checkoutPage/wizard/SET_STATE';
export const SET_STEPS = 'checkoutPage/wizard/SET_STEPS';
export const SET_CURRENT_STEP_BY_ID = 'checkoutPage/wizard/SET_CURRENT_STEP_BY_ID';
export const SET_STEP_DISABLED_BY_ID = 'checkoutPage/wizard/SET_STEP_DISABLED_BY_ID';
export const SET_LAST_ENABLED_STEP = 'checkoutPage/wizard/SET_LAST_ENABLED_STEP';
export const RESET_CHECKOUT_WIZARD = 'checkoutPage/wizard/RESET_CHECKOUT_WIZARD';
export const SET_HYBRID_CHECKOUT_FETCHING = 'checkoutPage/wizard/SET_HYBRID_CHECKOUT_FETCHING';
